import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/lean-fire-calculator',
  component: () => import('../../routes/LeanFireCalculator.svelte'),
  card: {
    id: 'lean-fire-calculator',
    title: 'Lean FIRE Calculator',
    description: 'Calculate your Lean FIRE number with a minimal retirement budget. See how small lifestyle changes dramatically reduce your path to financial independence.',
    icon: 'minimalize',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/lean-fire-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Lean FIRE Calculator – Financial Independence on a Minimal Budget',
    description: 'Free Lean FIRE calculator for Financial Independence with a lean/minimal budget. Calculate your Lean FI number, years to FI, and savings rate needed to retire early on $25,000-$40,000/year.',
  },
};

export default meta;
